import { createStore, applyMiddleware, compose } from "redux"
import reduxThunk from "redux-thunk"
import { getFirestore, reduxFirestore } from "redux-firestore"
import rootReducer from "reducers/rootReducer"
import fbConfig from "firebaseConfig"

const middleware = [
  reduxThunk.withExtraArgument({ getFirestore }),
  // This is where you add other middleware like redux-observable
]

function configureStore(
  state = { firebase: {}, firestore: {}, single: {}, organization: {} }
) {
  return createStore(
    rootReducer,
    state,
    compose(applyMiddleware(...middleware), reduxFirestore(fbConfig))
  )
}

export default configureStore
